import { render, staticRenderFns } from "./ShippingCompanyHead.vue?vue&type=template&id=6fc56e2c&scoped=true"
import script from "./ShippingCompanyHead.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyHead.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompanyHead.vue?vue&type=style&index=0&id=6fc56e2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc56e2c",
  null
  
)

export default component.exports